// extracted by mini-css-extract-plugin
export default {"FeedBackBlock":"FeedBackBlock_FeedBackBlock__R2bdG","FeedBackBlock_mobile":"FeedBackBlock_FeedBackBlock_mobile__YVxQh"};